import { themeVariables } from "Components/theme";
import React, { memo, useMemo } from "react";
import Styled from "./dotsIndicator.styled";
function DotsIndicator(props) {
    const containerStyle = useMemo(() => ({
        zIndex: props.zIndex
    }), [props.zIndex]);
    const messageStyle = useMemo(() => ({
        width: props.fullWidth ? (props.fullWidth * 3) / 4 : undefined,
        minHeight: themeVariables["line-height-computed"]
    }), [props.fullWidth]);
    return (React.createElement(Styled.Container, { style: containerStyle },
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("span", { style: messageStyle, className: "text-muted text-overflow-ellipsis", id: props.messageBoxId })));
}
export default memo(DotsIndicator);
